export interface IJobDetailsFields {
  fireAlarmOffering: boolean;
  fireSprinklerOffering: boolean;
  gaseousSystemOffering: boolean;
  ercesOffering: boolean;
  installationType: string;
  siteSize: number;
  antennaQty: number;
  agentWeight: number;
  cleanAgentNetVolSpace: number;
  isSiteSizeEnabled: boolean;
  isAntennaQtyEnabled: boolean;
  isAgentWeightEnabled: boolean;
  isCleanAgentNetVolSpaceEnabled: boolean;
}

export function createEmptyJobDetailsFields(): IJobDetailsFields {
  return {
    fireAlarmOffering: false,
    fireSprinklerOffering: false,
    gaseousSystemOffering: false,
    ercesOffering: false,
    installationType: '',
    siteSize: 0,
    antennaQty: 0,
    agentWeight: 0,
    cleanAgentNetVolSpace: 0,
    isSiteSizeEnabled: false,
    isAntennaQtyEnabled: false,
    isAgentWeightEnabled: false,
    isCleanAgentNetVolSpaceEnabled: false
  };
}